module.exports = __webpack_public_path__ + "static/media/ws.92e16684.svg";